import{d as o}from"./chunk-KVOZZCTJ.js";import{a as r,c as g}from"./chunk-HZZ24FOE.js";import{a as e,b as n,m as t}from"./chunk-HBP5N4FR.js";t();var p=()=>{let i=o(r),s=o(g);return n(e({},i),{isLoggedIn:s})};export{p as a};
//# sourceMappingURL=chunk-JTFAFFY2.js.map
